import React from "react";
import OutsideClickHandler from "react-outside-click-handler";
import PdfListButton from "./PdfList/PdfListButton";

function DropDownBody({ open, openHandler }) {
  const opened = open ? "d-block" : "none";

  return (
    <OutsideClickHandler onOutsideClick={() => openHandler(false)}>
      <div className="head-drop-menu">
        <ul className={`dropdown-menu ${opened}`}>
          <li className="dropdown-item">
            <PdfListButton />
          </li>
        </ul>
      </div>
    </OutsideClickHandler>
  );
}

export default DropDownBody;
